import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { TuiIcon } from '@taiga-ui/core';
import { BackButtonDirective } from '../directives/back-button.directive';

@Component({
  selector: 'pxc-back-navigation-button',
  templateUrl: './back-navigation-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BackButtonDirective, TuiIcon],
})
export class BackNavigationButtonComponent {
  private readonly translocoService = inject(TranslocoService);

  @Input() label = this.translocoService.translate('Retour');
  @Input() defaultUrl: string;
  @Input() forceDefault = false;
}
